import { Language } from '../../../views/layout/navbar/Langauge';

export const ENGLISH = 'en';
export const ARABIC = 'ar';
export const RTL = 'rtl';
export const LTR = 'ltr';

// export const LIGHT = 'light';
// export const DARK = 'dark';
export const REPORT_MAX_MONTH = 3;
export const SERVICES_REPORT_MAX_MONTH = 12;
export const MAX_FILE_SIZE = 2000000;
// export const APP_MODES = {
//   LIGHT,
//   DARK,
// }
export const APP_LANGS = [
  new Language({
    name: 'EN',
    abbr: ENGLISH,
    flag: '../../../assets/flags/global.svg',
    dir: LTR
  }),
  new Language({
    name: 'ع',
    abbr: ARABIC,
    flag: '../../../assets/flags/global.svg',
    dir: RTL,
    class: 'ar-font'
  })
];

export class SahredConstants {
  static readonly INITIAL_PAGE_INDEX: number = 1;
  static readonly INITIAL_PAGE_SIZE: number = 10;
}
